import React, { useState, } from 'react';
import { Container, Row, Col, Card, FormGroup, Label, Input, Button, CardBody, CardHeader } from 'reactstrap';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import '../Bi/stylePbi.css'
import { useReportSamplesP } from '../../../hooks/Pbi/useReportSamplesP';
import Select from 'react-select';
import { useReportLogExam } from '../../../hooks/Pbi/useReportLogExam';

export const IndexReportLogsExam = () => {
    const {
        mDateRange1, mDateRange2, mSelectUser, users, handleInputChange, handleSelectValues, reportLogs, loading, getReportLogs,
        exportExcel, filteredLogs, handleSearch, handleClean


    } = useReportLogExam();

    const header = (
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 pb-2">

            <div>

            </div>
            <Input
                type="search"
                placeholder="Buscar....."
                onChange={handleSearch}
                className="form-control"
                style={{
                    maxWidth: "400px",
                    borderRadius: "8px",
                    padding: "6px 10px",
                    fontSize: "14px",
                }}
            />
        </div>
    );

    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "12px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "12px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    return (
        <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
            <div style={{ paddingLeft: "5px", paddingRight: "5px", scrollBehavior: "smooth", transform: "scale(0.9)", width: "111%", transformOrigin: "top left", textAlign: "center", height: "20%" }}>
                <Card style={{
                    marginBottom: '15px',
                    background: 'linear-gradient(135deg, #002940 0%, #1d5b83 100%)',
                    border: 'none',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                }}>
                    <CardBody style={{ padding: '18px 25px' }}>
                        <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center">
                                <div style={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '12px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginRight: '15px'
                                }}>
                                    <img alt="flask" className="img-fluid text-info mr-2" src={require("../../../assets/images/laboratory-External/icon-laboratory.svg")} style={{ width: "60px", height: "60px" }} />
                                </div>
                                <div>
                                    <h4 className="mb-1" style={{ color: '#fff', fontWeight: 700, fontSize: '20px', textAlign: "justify" }}>
                                        Reporte Logs de Exámenes
                                    </h4>
                                    <small style={{ color: 'rgba(255, 255, 255, 0.85)', fontSize: '13px' }}>
                                        <i className="fa fa-info-circle mr-1"></i>
                                        Análisis detallado de los usuarios que realizan acciones en la captura de resultados.
                                    </small>
                                </div>
                            </div>

                        </div>
                    </CardBody>
                </Card>
                {
                    // *REPORT
                }
                <Card className='shadow-sm border height-equal pricingtable mb-0 pb-0' style={{ paddingTop: "1px", paddingLeft: "5px", paddingRight: "5px", scrollBehavior: "smooth", transform: "scale(0.9)", width: "113%", transformOrigin: "top left", textAlign: "center", height: "95%" }}>
                    <Col sm="12" className='pt-3'>
                        <Row>

                            <Col sm="2" className='p-l-0 p-r-0' style={{ textAlign: "left" }}>
                                <Card style={{
                                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                    border: 'none',
                                    height: '100%',
                                    borderRadius: '12px'
                                }}>
                                    <CardHeader style={{
                                        background: 'linear-gradient(135deg, #0d3b59 0%, #1d5b83 100%)',
                                        color: 'white',
                                        padding: '15px',
                                        borderRadius: '12px 12px 0 0'
                                    }}>
                                        <h6 className="mb-0" style={{ fontWeight: 700, fontSize: '15px' }}>
                                            <i className="fa fa-filter mr-2"></i>Filtros de Búsqueda
                                        </h6>
                                    </CardHeader>
                                    <CardBody style={{ padding: '20px' }}>
                                        <FormGroup>
                                            <Label className='f-w-600 label-report'>
                                                <i className="fa fa-calendar-alt mr-2" style={{ color: '#007bff' }}></i>Fecha de inicio
                                            </Label>
                                            <Input
                                                type='date'
                                                value={mDateRange1}
                                                name="mDateRange1"
                                                onChange={handleInputChange}
                                                className='form-control'
                                                style={{
                                                    borderRadius: '8px',
                                                    border: '1px solid #ddd',
                                                    padding: '10px',
                                                    fontSize: '13px'
                                                }}
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label className='f-w-600 label-report'>
                                                <i className="fa fa-calendar-check mr-2" style={{ color: '#28a745' }}></i>Fecha de cierre
                                            </Label>
                                            <Input
                                                type='date'
                                                value={mDateRange2}
                                                name="mDateRange2"
                                                onChange={handleInputChange}
                                                className='form-control'
                                                style={{
                                                    borderRadius: '8px',
                                                    border: '1px solid #ddd',
                                                    padding: '10px',
                                                    fontSize: '13px'
                                                }}
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label className='f-w-600 label-report' >
                                                <i className="fa fa-calendar-check mr-2" style={{ color: '#28a745' }}></i>Usuarios
                                            </Label>
                                            <Select
                                                name="mSelectUser"
                                                isClearable
                                                placeholder="Selecciona un usuario"
                                                options={users}
                                                onChange={(e) => handleSelectValues(e, 'mSelectUser')}
                                                value={mSelectUser}
                                                className="select-branch"
                                                 classNamePrefix="select"
                                                styles={{
                                                    control: (base) => ({
                                                        ...base,
                                                        textAlign: "left",
                                                    }),
                                                    singleValue: (base) => ({
                                                        ...base,
                                                        textAlign: "left",
                                                        width: "100%",
                                                    }),
                                                    option: (base) => ({
                                                        ...base,
                                                        textAlign: "left",
                                                    }),
                                                }}
                                            />
                                        </FormGroup>

                                        <br />
                                        <b>Acciones</b>
                                        <br /><br />
                                        <Button
                                            onClick={(e) => getReportLogs(e, true)}
                                            disabled={loading}
                                            color="primary"
                                            block
                                            outline
                                            className="mb-3"
                                            style={{
                                                borderRadius: '10px',
                                                padding: '6px',
                                                fontSize: '14px',
                                                fontWeight: 600,
                                                borderWidth: '2px'
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                        >
                                            Buscar
                                        </Button>
                                        <Button
                                            onClick={handleClean}
                                            color="danger"
                                            block
                                            outline
                                            className="mb-3"
                                            style={{
                                                borderRadius: '10px',
                                                padding: '6px',
                                                fontSize: '14px',
                                                fontWeight: 600,
                                                borderWidth: '2px'
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                        >
                                            Limpiar
                                        </Button>



                                        <Button
                                            color="success"
                                            onClick={exportExcel}
                                            block
                                            style={{
                                                borderRadius: '10px',
                                                padding: '6px',
                                                fontSize: '13px',
                                                fontWeight: 600,
                                                boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                                                transition: 'all 0.3s'
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                            title="Descargar reporte"
                                        >
                                            <i className="pi pi-file-excel"></i>&ensp;
                                            Descargar
                                        </Button>

                                    </CardBody>


                                </Card>
                            </Col>

                            <Col sm="10">
                                <div style={{
                                    marginTop: '1px',
                                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                    borderRadius: '12px',
                                    overflow: 'hidden',
                                    backgroundColor: '#fff'
                                }}>
                                    <DataTable value={filteredLogs} paginator rows={10} className="data-table p-datatable-striped p-datatable-sm"
                                        emptyMessage={
                                            <div className="text-center">
                                                <img src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")} style={{ width: "20%" }} alt="Sin Usuarios" />
                                                <br />
                                                <p className='badge badge-light-primary mt-2' style={{ fontSize: "15px" }}>
                                                    Sin logs de examenes.
                                                </p>
                                            </div>
                                        }
                                        rowsPerPageOptions={[10, 50, 100]}
                                        responsiveLayout="scroll"
                                        stripedRows
                                        header={header}
                                        loading={loading}
                                    >
                                        <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="#" headerStyle={headerStyle} style={cellStyle} />
                                        <Column
                                            field="user"
                                            header="Usuario"
                                            sortable
                                            headerStyle={headerStyle}
                                            style={{ ...cellStyle, textAlign: "center", verticalAlign: "middle" }}
                                            body={(rowData) => {
                                                if (!rowData.user) return null;

                                                return (
                                                    <span
                                                        style={{
                                                            display: "inline-block",
                                                            padding: "4px 10px",
                                                            borderRadius: "12px",
                                                            backgroundColor: "#f97316",
                                                            color: "#fff",
                                                            fontWeight: "bold",
                                                            fontSize: "11px",
                                                            textAlign: "center",
                                                        }}
                                                    >
                                                        {rowData.user}
                                                    </span>
                                                );
                                            }}
                                        />
                                        <Column field="full_name" header="Nombre" sortable headerStyle={headerStyle} style={cellStyle} />
                                        <Column field="created_at" header="Fecha" sortable headerStyle={headerStyle} style={cellStyle} />
                                        <Column field="nim" header="Nim" sortable headerStyle={headerStyle} style={cellStyle} />
                                        <Column
                                            field="action"
                                            header="Estudio/Acciones"
                                            sortable
                                            headerStyle={headerStyle}
                                            style={cellStyle}
                                            body={(rowData) => {
                                                if (!rowData.action) return null;

                                                const [exam, description] = rowData.action.split(" - ");

                                                return (
                                                    <div>
                                                        <span style={{ color: "#0079c7", fontWeight: "bold" }}>{exam}</span>
                                                        {description && (
                                                            <>
                                                                {" - "}
                                                                {description}
                                                            </>
                                                        )}
                                                    </div>
                                                );
                                            }}
                                        />

                                    </DataTable>
                                </div>
                            </Col>



                        </Row>

                    </Col>

                </Card>
            </div >
        </div >






        // <Container fluid={true}>
        //     <div style={{ transform: "scale(0.8)", width: "125%", transformOrigin: "top left" }}>
        //         <Row>
        //             <Col sm="12">
        //                 <Card className='height-equal pt-0 pb-0 pr-0 pl-0 pt-3'>
        //                     <div className="ribbon ribbon-clip ribbon-primary">Reporte Logs Examenes</div>

        //                     <FormGroup>
        //                         <Row>

        //                             <Col xs="12" md="2" className="mb-2 d-flex flex-column align-items-start justify-content-end">

        //                             </Col>


        //                             <Col xs="12" md="2" className="mb-2 d-flex flex-column align-items-start justify-content-end">
        //                                 <Label className="f-w-600 f-12 badge badge-light-primary">Fecha de inicio</Label>
        //                                 <Input
        //                                     type="date"
        //                                     value={mDateRange1}
        //                                     name="mDateRange1"
        //                                     onChange={handleInputChange}
        //                                     className="form-control form-control-sm input-air-primary b-r-9"
        //                                     placeholder="YYYY-MM-DD"
        //                                 />
        //                             </Col>

        //                             <Col xs="12" md="2" className="mb-2 d-flex flex-column align-items-start justify-content-end">
        //                                 <Label className="f-w-600 f-12 badge badge-light-primary">Fecha de cierre</Label>
        //                                 <Input
        //                                     type="date"
        //                                     value={mDateRange2}
        //                                     name="mDateRange2"
        //                                     onChange={handleInputChange}
        //                                     className="form-control form-control-sm input-air-primary b-r-9"
        //                                     placeholder="YYYY-MM-DD"
        //                                 />
        //                             </Col>

        //                             <Col xs="12" md="2"  style={{ borderRadius: "15px", height: "35px", width: "100%", fontSize: "12px" }}>
        //                                 <Label className="f-w-600 f-12 badge badge-light-primary">Usuarios</Label>
        //                                 <Select
        //                                 name="mSelectUser"
        //                                 isClearable
        //                                 placeholder="Selecciona un usuario"
        //                                 options={users}
        //                                 onChange={(e) => handleSelectValues(e, 'mSelectUser')}
        //                                 value={mSelectUser}
        //                                 className="select-branch"
        //                                 styles={{
        //                                     control: (base) => ({
        //                                     ...base,
        //                                     textAlign: "left",
        //                                     }),
        //                                     singleValue: (base) => ({
        //                                     ...base,
        //                                     textAlign: "left",
        //                                     width: "100%",
        //                                     }),
        //                                     option: (base) => ({
        //                                     ...base,
        //                                     textAlign: "left",
        //                                     }),
        //                                 }}
        //                                 />


        //                             </Col>


        //                             <Col xs="12" md="3" className="mb-2 d-flex flex-column align-items-start justify-content-end">
        //                                 <Label className="f-w-600 f-12 badge badge-light-primary">Acciones</Label>
        //                                 <div>
        //                                     <Button
        //                                         onClick={(e) => getReportLogs(e, true)}
        //                                         outline
        //                                         color="primary"
        //                                         size="sm"
        //                                         disabled={loading}
        //                                     >
        //                                         Filtrar
        //                                     </Button>
        //                                     <Button
        //                                         onClick={handleClean}
        //                                         outline
        //                                         color="danger"
        //                                         size="sm"
        //                                         disabled={loading}
        //                                         className="ml-2"
        //                                     >
        //                                         Limpiar
        //                                     </Button>
        //                                 </div>
        //                             </Col>
        //                         </Row>
        //                     </FormGroup>

        //                     <DataTable value={filteredLogs} paginator rows={10} className="data-table p-datatable-striped p-datatable-sm"
        //                         emptyMessage={
        //                             <div className="text-center">
        //                                 <img src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")} style={{ width: "20%" }} alt="Sin Usuarios" />
        //                                 <br />
        //                                 <p className='badge badge-light-primary mt-2' style={{ fontSize: "15px" }}>
        //                                     Sin logs de examenes.
        //                                 </p>
        //                             </div>
        //                         }
        //                         rowsPerPageOptions={[10, 50, 100]}
        //                         responsiveLayout="scroll"
        //                         header={header}
        //                         loading={loading}
        //                     >
        //                             <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="#" headerStyle={headerStyle} style={cellStyle} />
        //                             <Column
        //                             field="user"
        //                             header="Usuario"
        //                             sortable
        //                             headerStyle={headerStyle}
        //                             style={{ ...cellStyle, textAlign: "center", verticalAlign: "middle" }}
        //                             body={(rowData) => {
        //                                 if (!rowData.user) return null;

        //                                 return (
        //                                 <span
        //                                     style={{
        //                                     display: "inline-block",
        //                                     padding: "4px 8px",
        //                                     borderRadius: "12px",
        //                                     backgroundColor: "#25acd4ff",
        //                                     color: "#fff",
        //                                     fontWeight: "bold",
        //                                     fontSize: "10px",
        //                                     textAlign: "center",
        //                                     }}
        //                                 >
        //                                     {rowData.user}
        //                                 </span>
        //                                 );
        //                             }}
        //                             />
        //                             <Column field="full_name" header="Nombre" sortable headerStyle={headerStyle} style={cellStyle}/>
        //                             <Column field="created_at" header="Fecha" sortable headerStyle={headerStyle} style={cellStyle}/>
        //                             <Column field="nim" header="Nim" sortable headerStyle={headerStyle} style={cellStyle}/>
        //                             <Column
        //                                 field="action"
        //                                 header="Estudio/Acciones"
        //                                 sortable
        //                                 headerStyle={headerStyle}
        //                                 style={cellStyle}
        //                                 body={(rowData) => {
        //                                     if (!rowData.action) return null;

        //                                     const [exam, description] = rowData.action.split(" - ");

        //                                     return (
        //                                     <div>
        //                                         <span style={{ color: "#25acd4ff", fontWeight: "bold" }}>{exam}</span>
        //                                         {description && (
        //                                         <>
        //                                             {" - "}
        //                                             {description}
        //                                         </>
        //                                         )}
        //                                     </div>
        //                                     );
        //                                 }}
        //                             />

        //                     </DataTable>

        //                     <br /><br />
        //                 </Card>

        //             </Col>


        //         </Row>
        //     </div>

        // </Container>
    );
};
